module.exports = __webpack_public_path__ + "static/media/IDVA logo-01.669b9d41.png";